<template>
  <a :href="fileSource" target="_blank" rel="noopener">{{ name }}</a>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { getFullPathForPublicAssets } from '@/utils/url';

const props = defineProps({
  name: { type: String, required: true },
  href: { type: String, required: true },
});
const fileSource = computed(() => (props.href.startsWith('/') ? getFullPathForPublicAssets(props.href) : props.href));
</script>
